export const PRICES = {
  basic: {
    month: {
      GBP: 0,
      USD: 0,
    },
    year: {
      GBP: 0,
      USD: 0,
    },
  },

  standard: {
    month: {
      GBP: 5,
      USD: 5,
    },
    year: {
      GBP: 36,
      USD: 20,
    },
  },

  premium: {
    month: {
      GBP: 7,
      USD: 8,
    },
    year: {
      GBP: 60,
      USD: 30,
    },
  },
};



// WEBPACK FOOTER //
// ./library/app/components/Signup/Prices.js